export const SET_IS_FETCHING_REPORTS = "SET_IS_FETCHING_REPORTS";
export const SET_REPORTS = "SET_REPORTS";
export const SET_USER_REPORTS = "SET_USER_REPORTS";
